import { fetcher } from "@certn/api";
import { Text, Link } from "@certn/cascadia";
import { SectionMessage, SummaryCard } from "@certn/cascadia-react";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { useApplicationFormContext } from "../../../ApplicationFormContext";
import { useContext } from "react";
import { ApplicationContext } from "../../../ApplicationContext";

export function NonBiometricIdSummaryControl() {
  const { t } = useTranslation();
  const { caseId } = useApplicationFormContext();
  const { basePath = "apply" } = useContext(ApplicationContext) || {};
  const [optOutReason, setOptOutReason] = useState<string | null>(null);
  const [otherReason, setOtherReason] = useState<string | null>(null);

  const getOptOutValues = useCallback(async () => {
    try {
      const { opt_out_reason, other_reason } = await fetcher.request<{
        opt_out_reason: string;
        other_reason: string;
      }>(
        `/api/internal/applicant/case/${caseId}/opt-out-claim-values/non_biometric_id_verification_opt_out/`
      );
      setOptOutReason(opt_out_reason);
      setOtherReason(other_reason);
    } catch (e) {
      console.error("Error getting opt out values", e);
    }
  }, [caseId]);

  useEffect(() => {
    getOptOutValues();
  }, [getOptOutValues]);

  return (
    <SummaryCard
      header={t("Identity Verification")}
      testID="identity-verification-summary"
      actions={
        <Link
          href={`/${basePath}/${caseId}/one-id`}
          textColor="text-weak"
          testID="identity-verification-edit-button"
        >
          {t("Edit")}
        </Link>
      }
    >
      <SectionMessage
        sectionTitle={t("Unable to verify via my bank")}
        type="warning"
        icon="warning"
      >
        <Text>{t("Reason: {{reason}}", { reason: optOutReason ?? "--" })}</Text>
        {otherReason && <Text>, {otherReason}</Text>}
      </SectionMessage>
    </SummaryCard>
  );
}
